<template>
    <div class="notice">
        <h1>공지사항</h1>
        <div class="notice-board">
            <table width="100%" cellspacing="0" cellpadding="0" border="0" summary="공지사항 리스트">
                <caption style="display: none;">공지사항 리스트</caption>
                <colgroup>
                    <col width="80%">
                    <col width="20%">
                </colgroup>
                <thead>
                    <tr>
                        <th>제목</th>
                        <th>등록일</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>MDtalk 의사용 웹 업데이트 안내</td>
                        <td>2018-03-12</td>
                    </tr>
                    <tr>
                        <td>MDtalk 의사용 웹 업데이트 안내</td>
                        <td>2018-03-02</td>
                    </tr>
                    <tr>
                        <td>[ios] 환자용 앱 1.2.4 업데이트 안내</td>
                        <td>2018-02-10</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
            <div class="notice-pager clearfix">
                <ul class="pager-list">
                    <li class="on">1</li>
                    <li>2</li>
                    <li>3</li>
                    <li>4</li>
                    <li>5</li>
                </ul>
                <span class="pager-next">&gt;</span>
            </div>
        </div>

    </div>
    
</template>

<script>
  export default {
    name: 'notice'
  }
</script>

<style scoped>
    .notice h1 {
        color: #474747;
        margin: 50px 0;
        text-align: center;
        letter-spacing: -.5px;
        font: 400 32px 'Noto Sans KR', sans-serif;
    }

    .notice-board {
        width: 100%;
        max-width: 1280px;
        margin: 55px auto 100px;
        position: relative;
        background-color: #fff;
        border: 1px solid #eee;
        box-sizing: border-box;
    }

    .notice-board th, .notice-board td {
        vertical-align: middle;
    }

    .notice-board th {
        color: #989898;
        height: 50px;
        font: 400 15px 'Noto Sans KR', sans-serif;
    }

    .notice-board td {
        height: 70px;
        border-top: 1px solid #eee;
        font: 400 16px 'Noto Sans KR', sans-serif;
    }

    .notice-board td:first-of-type {text-indent: 40px;}
    .notice-board td:last-of-type {text-align: center;}

    /* Pager */
    .notice-pager {
        position: absolute;
        left: 50%;
        transform: translate(-50%, 30px);
    }

    .notice-pager .pager-list,
    .notice-pager .pager-next {
        float: left;
    }

    .notice-pager .pager-list {
        font-size: 0;
    }

    .notice-pager .pager-list > li {
        display: inline-block;
        width: 24px;
        height: 24px;
        margin-right: 10px;
        text-align: center;
        font: 400 13px/24px 'Noto Sans KR', sans-serif;
    }

    .notice-pager .pager-list > li.on {
        border: 1px solid #736ee6;
    }

    .notice-pager .pager-next {
        color: #c8c9cb;
        display: inline-block;
        width: 24px;
        height: 24px;
        text-align: center;
        border: 1px solid #c8c9cb;
        font: 400 14px/24px 'Roboto', sans-serif;
    }
</style>